module.exports = __webpack_public_path__ + "static/media/home_male.cd6f46a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_male.png
// module id = 109
// module chunks = 0